import { Injectable } from '@angular/core';
import { CalendarEvent } from '../../interfaces/project-detail.interface';

@Injectable({ providedIn: 'root' })
export class ProjectDataAdapterService {

  /**
   * Adapts a legacy project (old schema) to the new schema expected by new-proyect2.
   */
  adaptLegacyProject(project: any): any {
    if (!project) return project;

    // Already new format if it has 'properties' array
    if (project.properties && Array.isArray(project.properties)) {
      return project;
    }

    // Build a single property from legacy flat fields
    const property: any = {
      // Identity
      name: project.title || '',
      mainImage: project.mainImage || project.urlImagenPrincipal || null,

      // Location
      country: project.country || project.pais || '',
      stateRegion: project.stateCCAAProvince || project.estadoCCAAProvincia || '',
      city: project.location || project.localidad || '',
      neighborhood: project.neighborhood || project.barrio || '',
      postalCode: project.cp || project.codigoPostal || '',
      street: project.street || project.calle || '',
      googleMapsIframe: project.iframeGoogleMaps || project.googleMapsIframe || '',

      // Description
      description: project.description || project.descripcion || '',

      // Attributes
      attributes: project.attributes || project.atributos || '{}',
      atributos: project.atributos || project.attributes || '{}',

      // Gallery
      gallery: project.images || [],

      // Financial
      financialSections: project.financialSections || [],

      // Calendar
      calendarEvents: project.calendarEvents || [],

      // Documents
      documents: project.documents || [],

      // Status
      status: project.proyectStatus || project.status || 'Under Study',
      estado: project.proyectStatus || project.status || 'Under Study',
    };

    return {
      ...project,
      // New schema fields mapped from legacy
      title: project.title,
      developer: project.company || project.developer || '',
      stateRegion: project.stateCCAAProvince || project.stateRegion || '',
      city: project.location || project.city || '',
      postalCode: project.cp || project.postalCode || '',
      googleMapsIframe: project.iframeGoogleMaps || project.googleMapsIframe || '',
      annualProfitability: project.annualReturn || project.annualProfitability || null,
      tokenPrice: project.priceToken || project.tokenPrice || null,
      minimumInvestment: project.minimumInvestment || project.inversionMinima || null,
      aggregatorStableCoinDollar: project.aggregatorStableCoinDolar || project.aggregatorStableCoinDollar || '',
      onlyInvestors: project.onlyInversors || project.onlyInvestors || false,
      tokenName: project.nameTokens || project.tokenName || '',
      tokenSymbol: project.symbolTokens || project.tokenSymbol || '',
      projectInfo: project.infoProyecto || project.projectInfo || '',
      toBlockchain: project.blockchain || project.toBlockchain || false,
      mainPropertyIndex: project.mainPropertyIndex ?? 0,
      mainPropertyCoverIndex: project.mainPropertyCoverIndex ?? 0,
      // Wrap into properties array
      properties: [property],
    };
  }

  /**
   * Creates default calendar events for a new project.
   */
  createDefaultCalendarEvents(options: any = {}): CalendarEvent[] {
    const now = new Date();
    return [
      {
        id: `evt-${Date.now()}-1`,
        title: 'Lanzamiento del proyecto',
        date: null,
        type: 'milestone',
        status: 'pending',
        description: '',
        completed: false,
      },
      {
        id: `evt-${Date.now()}-2`,
        title: 'Inicio de obras',
        date: null,
        type: 'milestone',
        status: 'pending',
        description: '',
        completed: false,
      },
      {
        id: `evt-${Date.now()}-3`,
        title: 'Fin de obras estimado',
        date: null,
        type: 'milestone',
        status: 'pending',
        description: '',
        completed: false,
      },
    ];
  }
}
